export default __webpack_public_path__ + "static/media/rabbit33.5cce03d6.gif";